import React from "react";

/**
 * Decorative gradient strip uses the WeDo brand multi-color gradient.
 * Inspired by the reference newsletter/PDF.
 */
export default function GradientStrip({ height = "h-1.5", className = "" }) {
  return (
    <div
      data-testid="gradient-strip"
      className={`w-full ${height} ${className}`}
      style={{
        background:
          "linear-gradient(90deg, #9DBC1D 0%, #EEE316 18%, #F3A114 36%, #E62C86 58%, #1C1580 80%, #52A385 100%)",
      }}
    />
  );
}
